import { useEffect, useState } from "react";
import {
  ArrowSquareOut,
  DownloadSimple,
  WifiHigh,
  WifiSlash,
} from "@phosphor-icons/react";

export default function PwaControls() {
  const [installPrompt, setInstallPrompt] = useState(null);
  const [installed, setInstalled] = useState(false);
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;

    setInstalled(isStandalone);

    const onPrompt = (event) => {
      event.preventDefault();
      setInstallPrompt(event);
    };

    const onInstalled = () => {
      setInstalled(true);
      setInstallPrompt(null);
    };

    const onOnline = () => setOnline(true);
    const onOffline = () => setOnline(false);

    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        onPrompt
      );
      window.removeEventListener(
        "appinstalled",
        onInstalled
      );
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, []);

  const installApp = async () => {
    if (!installPrompt) {
      window.alert(
        "Su iPhone usa Safari: Condividi → Aggiungi alla schermata Home. Su Chrome usa il menu Installa app."
      );
      return;
    }

    await installPrompt.prompt();
    const result = await installPrompt.userChoice;

    if (result.outcome === "accepted") {
      setInstalled(true);
      setInstallPrompt(null);
    }
  };

  const openApp = () => {
    window.location.href =
      "https://www.adueasrl.it/magazzino/";
  };

  return (
    <div className="flex items-center gap-2">
      <div
        className={`hidden sm:inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-xs font-medium ${
          online
            ? "bg-green-50 text-green-700"
            : "bg-orange-50 text-orange-700"
        }`}
      >
        {online ? (
          <WifiHigh size={15} weight="bold" />
        ) : (
          <WifiSlash size={15} weight="bold" />
        )}

        {online ? "Online" : "Offline"}
      </div>

      <button
        type="button"
        onClick={installed ? openApp : installApp}
        className="inline-flex h-9 items-center gap-2 rounded-md bg-slate-900 px-3 text-sm font-medium text-white transition hover:bg-slate-800"
      >
        {installed ? (
          <ArrowSquareOut size={17} weight="bold" />
        ) : (
          <DownloadSimple size={17} weight="bold" />
        )}

        <span className="hidden sm:inline">
          {installed ? "Apri app" : "Installa app"}
        </span>
      </button>
    </div>
  );
}
